import React from 'react';
import Icon from '@ant-design/icons';
import { ButtonType, Button } from 'components/Controls/Button';
import { IconButtonProps } from 'components/Icons/constants';
import ArrowLeftSvg from './arrowLeft.svg';

export const ArrowLeftIcon = (props: any) => <Icon component={ArrowLeftSvg} {...props} />;

export const ArrowLeftButton = ({ size = 'medium', iconSize = 24, ...props }: IconButtonProps) => (
  <Button
    type={ButtonType.OutlineIcon}
    icon={<ArrowLeftIcon width={iconSize} height={iconSize} />}
    size={size}
    {...props}
  />
);
